import { render, staticRenderFns } from "./team.pug?vue&type=template&id=563b0b67&"
import script from "./team.js?vue&type=script&lang=js&"
export * from "./team.js?vue&type=script&lang=js&"
import style0 from "./team.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports